import { render, staticRenderFns } from "./Ticketing.html?vue&type=template&id=bf8647c2&"
import script from "./Ticketing.js?vue&type=script&lang=js&"
export * from "./Ticketing.js?vue&type=script&lang=js&"
import style0 from "./Ticketing.scss?vue&type=style&index=0&lang=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports